import { Box, InputCheckBox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Select'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { NEGATIVE_TRANSFERS } from 'modules/attendance/lib/enums'
import type TimeoffCompensationForm from 'modules/timeoff/lib/TimeoffCompensationForm'

import useIsRecentCompany from '../../hooks/useIsRecentCompany'

interface NegativeBalanceProps {
  form: TimeoffCompensationForm
}

interface IKeys {
  [key: string]: string
}

const NegativeBalance = ({ form }: NegativeBalanceProps) => {
  const negativeTransfersEnabled = form.negativeTransfersEnabled()

  const negativeTransfersWarningI18n: IKeys = {
    [NEGATIVE_TRANSFERS.limited]: i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.negative_transfers.warning.limited'
    ),
    [NEGATIVE_TRANSFERS.unlimited]: i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.negative_transfers.warning.unlimited'
    ),
  }

  const negativeTransfersI18n: IKeys = {
    [NEGATIVE_TRANSFERS.limited]: i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.fields.negative_transfers.limited'
    ),
    [NEGATIVE_TRANSFERS.unlimited]: i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.fields.negative_transfers.unlimited'
    ),
  }

  const negativeTransfersOptions = form.negativeTransfersOptions().map((negative_transfer) => ({
    label: negativeTransfersI18n[negative_transfer] || '',
    value: negative_transfer,
  }))
  const isRecentCompany = useIsRecentCompany()

  return (
    <Box gap="s16">
      <Box flexDirection="column" gap="s4">
        <Box flexDirection="row" alignItems="center" gap="s4">
          <InputCheckBox
            checked={negativeTransfersEnabled}
            onClick={() => {
              form.onNegativeTransfersChange()
              track(trackingEvents.timeTracking.negativeBalanceSettlementPressed, {
                option: !negativeTransfersEnabled,
              })
            }}
          />
          <Text.Normal size="300" weight="medium">
            {i18n.t(
              'time_tracking.settings.overtime.compensation.timeoff.form.negative_transfers.title'
            )}
          </Text.Normal>
        </Box>
        <Text size="200">
          {i18n.t(
            'time_tracking.settings.overtime.compensation.timeoff.form.negative_transfers.explanation'
          )}
        </Text>
      </Box>
      {negativeTransfersEnabled && !isRecentCompany && (
        <Box gap="s4">
          <Select
            value={form.get('negative_transfers').value}
            label={i18n.t(
              'time_tracking.settings.overtime.compensation.timeoff.form.labels.behaviour_options'
            )}
            options={negativeTransfersOptions}
            onChange={(selected) => form.setValues({ negative_transfers: selected })}
            showOriginalLabelText
          />
          <Text.Normal size="200">
            {negativeTransfersWarningI18n[form.get('negative_transfers').value]}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default observer(NegativeBalance)
